/*
 * @message:
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2022-01-06 17:28:35
 * @FilePath: \mrc-base-frontend\src\service\api\pushLangTemplate.js
 * @最后编辑: Betway
 * @最后修改时间: 2022-01-07 12:07:42
 */
// 消息模板
import http from "../httpConfig";

const table = "mrbase_sys_message_push_template_language";

// 获取模板列表
export const getLangTemplateList = (params = {}) => {
  params["~table~"] = table;
  return new Promise((resolve, reject) => {
    http
      .post("/api/message/push/get-template-language-value-list/v1", params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
// 获取模板详情
// export const getLangTemplateDetail = (params = {}) => {
//   params["~table~"] = table;
//   return new Promise((resolve, reject) => {
//     http
//       .post("/api/message/push/get-template/v1", params)
//       .then((res) => {
//         resolve(res);
//       })
//       .catch((err) => {
//         reject(err);
//       });
//   });
// };

// 模板新增
export const addLangTemplateDetail = (params = {}) => {
  params["~table~"] = table;
  return new Promise((resolve, reject) => {
    http
      .post("/api/message/push/add-template-language-value/v1", params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// Lang模板修改
export const updateLangTemplateDetail = (params = {}) => {
  params["~table~"] = table;
  return new Promise((resolve, reject) => {
    http
      .post("/api/message/push/update-template-language-value/v1", params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// Lang模板删除
export const deleteLangTemplateDetail = (params = {}) => {
  params["~table~"] = table;
  return new Promise((resolve, reject) => {
    http
      .post("/api/message/push/delete-template-language-value/v1", params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
